export const makePlaceholdersForFrontend = (
  html: string,
  placeholders: Record<string, string>,
) => {
  Object.keys(placeholders).forEach((pKey) => {
    html = html.split(`{${pKey}}`).join(`{${placeholders[pKey]}}`);
  });
  return html;
};
